import React from 'react'

import BubbleMessage from './BubbleMessage'

/** Shows the outcome of a copy-questionnaire-to-schools call as BubbleMessage bubbles:
 * a success bubble naming the schools the questionnaire was newly added to, and a
 * warning bubble naming the schools that already had it (and were therefore skipped).
 *
 * `results` is expected to look like { success: [{id, name}, ...], fail: [{id, name}, ...] }
 * - the same shape the copy endpoints return.
 */
export default ({ results }) => {
  if (!results) {
    return null
  }

  const { success = [], fail = [] } = results
  if (success.length === 0 && fail.length === 0) {
    return null
  }

  return (
    <React.Fragment>
      {success.length > 0 &&
        <BubbleMessage
          type="success"
          text={I18N._("Questionnaire added to") + ": " + success.map((school) => school.name).join(", ")}
        />
      }
      {fail.length > 0 &&
        <BubbleMessage
          type="warning"
          text={fail.map((school) => school.name).join(", ") + ": " + I18N._("this school already has a questionnaire with the same questions")}
        />
      }
    </React.Fragment>
  )
}
